import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const TYPE_TEXT = '[Type: Text][Vis: high] - Feature Set Cell Value Item';

export default defineMessages({
  base_response_count: {
    id: 'Pricing.cellCopy.BaseResponseCount',
    defaultMessage: '{amount} responses per year**',
    desc: {
      id: 'Pricing.cellCopy.BaseResponseCount',
      message: `${TYPE_TEXT} - BaseResponseCount`,
      project: PROJECT_NAME,
    },
  },
  num_free_responses: {
    id: 'Pricing.cellCopy.NumFreeResponses',
    defaultMessage: '{amount} responses per month**',
    desc: {
      id: 'Pricing.cellCopy.NumFreeResponses',
      message: `${TYPE_TEXT} - NumFreeResponses`,
      project: PROJECT_NAME,
    },
  },
  create_question_limit: {
    id: 'Pricing.cellCopy.CreateQuestionLimit',
    defaultMessage: '{amount} questions per survey',
    desc: {
      id: 'Pricing.cellCopy.CreateQuestionLimit',
      message: `${TYPE_TEXT} - CreateQuestionLimit`,
      project: PROJECT_NAME,
    },
  },
  collector_create_limit: {
    id: 'Pricing.cellCopy.CollectorCreateLimit',
    defaultMessage: 'Use {amount} collectors per survey',
    desc: {
      id: 'Pricing.cellCopy.CollectorCreateLimit',
      message: `${TYPE_TEXT} - CollectorCreateLimit`,
      project: PROJECT_NAME,
    },
  },
  CONTACT_US: {
    id: 'Pricing.cellCopy.ContactUsBaseResponseCount',
    defaultMessage: 'Contact Us',
    desc: {
      id: 'Pricing.cellCopy.ContactUsBaseResponseCount',
      message: `${TYPE_TEXT} - ContactUsBaseResponseCount`,
      project: PROJECT_NAME,
    },
  },
  BASIC_COMPARE_FILTER: {
    id: 'Pricing.cellCopy.BasicCompareFilter',
    defaultMessage: '1 filter',
    desc: {
      id: 'Pricing.cellCopy.BasicCompareFilter',
      message: `${TYPE_TEXT} - BasicCompareFilter`,
      project: PROJECT_NAME,
    },
  },
  BASIC_NUM_RESPONSES: {
    id: 'Pricing.cellCopy.BasicNumberOfResponses',
    defaultMessage: 'View {amount} responses per survey',
    desc: {
      id: 'Pricing.cellCopy.BasicNumberOfResponses',
      message: `${TYPE_TEXT} - BasicNumberOfResponses`,
      project: PROJECT_NAME,
    },
  },
  MANUAL: {
    id: 'Pricing.cellCopy.Manual',
    defaultMessage: 'Manual',
    desc: {
      id: 'Pricing.cellCopy.Manual',
      message: `${TYPE_TEXT} - Manual`,
      project: PROJECT_NAME,
    },
  },
  MANUAL_RULE: {
    id: 'Pricing.cellCopy.ManualRule',
    defaultMessage: 'Manual and Rule-based',
    desc: {
      id: 'Pricing.cellCopy.ManualRule',
      message: `${TYPE_TEXT} - ManualRule`,
      project: PROJECT_NAME,
    },
  },
  TEMPLATE_ENABLED_VALUE: {
    id: 'Pricing.cellCopy.TemplateEnabledValue',
    defaultMessage: '180 +',
    desc: {
      id: 'Pricing.cellCopy.TemplateEnabledValue',
      message: `${TYPE_TEXT} - TemplateEnabledValue`,
      project: PROJECT_NAME,
    },
  },
  BASIC_TEMPLATE_ENABLED_VALUE: {
    id: 'Pricing.cellCopy.BasicTemplateEnabledValue',
    defaultMessage: '40 short survey templates',
    desc: {
      id: 'Pricing.cellCopy.BasicTemplateEnabledValue',
      message: `${TYPE_TEXT} - BasicTemplateEnabledValue`,
      project: PROJECT_NAME,
    },
  },
  BASIC_WEBLINK_AND_SOCIAL_ENABLED_VALUE: {
    id: 'Pricing.cellCopy.BasicWeblinkAndSocialEnabledValue',
    defaultMessage: 'Web and Social collection only',
    desc: {
      id: 'Pricing.cellCopy.BasicWeblinkAndSocialEnabledValue',
      message: `${TYPE_TEXT} - BasicWeblinkAndSocialEnabledValue`,
      project: PROJECT_NAME,
    },
  },
  UNLIMITED: {
    id: 'Pricing.cellCopy.Unlimited',
    defaultMessage: 'UNLIMITED',
    desc: {
      id: 'Pricing.cellCopy.Unlimited',
      message: `${TYPE_TEXT} - Unlimited`,
      project: PROJECT_NAME,
    },
  },
});
